export default "__VITE_ASSET__3d34eaf0__"